<template>
  <div class="modal-card" data-test-id="sectionCreationModal">
    <header class="modal-card-head">
      <b-button 
        icon-pack="fas" 
        icon-left="times" 
        @click="emitClose" 
        :aria-label="$t('Close')"
      />
    </header>
    <section class="modal-card-body">
      <section-edit
        :shopping-center-group-id="shoppingCenterGroupId"
        :can-edit-shop="canEditShop"
        @section-create-completed="sectionUpdateComplete"
        @section-create-canceled="cancelUpdate"
      />
    </section>
    <footer class="modal-card-foot">
      <b-button @click="emitClose">{{ $t('Close') }}</b-button>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import sectionEdit from '@/components/sectionEdit.vue'
import type { Section } from '@/stores/app'

// Define props with strict TypeScript support
interface Props {
  shoppingCenterGroupId: string | number
  canEditShop?: boolean
}

withDefaults(defineProps<Props>(), {
  canEditShop: true
})

// Define emits with strict TypeScript support
interface Emits {
  (e: 'section-create-completed', section: Section): void
  (e: 'close'): void
}

const emit = defineEmits<Emits>()

const closeQueued = ref(false)

// Methods with proper TypeScript typing
const sectionUpdateComplete = (newSection: Section): void => {
  emit('section-create-completed', newSection)
  emitClose()
}

const cancelUpdate = (): void => {
  emitClose()
}

const emitClose = (): void => {
  if (closeQueued.value) {
    return
  }

  closeQueued.value = true
  try {
    emit('close')
  } finally {
    queueMicrotask(() => {
      closeQueued.value = false
    })
  }
}
</script>
